module.exports = __webpack_public_path__ + "img/0S6A0034.a4611e86.jpg";